import { render, staticRenderFns } from "./ListOfInstruments.vue?vue&type=template&id=6cd6a034&"
import script from "./ListOfInstruments.vue?vue&type=script&lang=js&"
export * from "./ListOfInstruments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports